function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "#073C50",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M2.3692281,4.90420122 C2.3940207,4.66027268 2.29892855,4.41630376 2.1170219,4.25091206 L0.252206199,2.00156872 L0.252206199,1.66666667 L6.04919353,1.66666667 L10.5313249,11.4950768 L14.4717742,1.66666667 L20,1.66666667 L20,2.00156872 L18.4039458,3.53144199 C18.2675057,3.6348118 18.1972062,3.80848117 18.2261578,3.9780319 L18.2261578,15.2246678 C18.1972062,15.3941782 18.2675057,15.5678475 18.4039458,15.6712174 L19.9627707,17.2010906 L19.9627707,17.5359927 L12.119061,17.5359927 L12.119061,17.2010906 L13.7357892,15.6339881 C13.8929032,15.476874 13.8929032,15.4272484 13.8929032,15.1874385 L13.8929032,6.09917244 L9.39837556,17.5070411 L8.79055297,17.5070411 L3.56419932,6.09917244 L3.56419932,13.7443798 C3.51869237,14.0669259 3.62622121,14.3894316 3.8536348,14.6209639 L5.95410138,17.1680204 L5.95410138,17.5029224 L0,17.5029224 L0,17.172139 L2.10046658,14.6209639 C2.32376153,14.3894316 2.42713135,14.0627669 2.3692281,13.7443798 L2.3692281,4.90420122 Z"
}));

var SvgMedium = function SvgMedium(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMedium, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/medium.2e4f24db.svg";
export { ForwardRef as ReactComponent };